import React, { Component } from 'react';
import "./index.less";
import { getPlatformName, requests, messageShow, getLoginShopInfo, matchSupplierProduct, systemConfig, isNotNull } from '../../utils/http.js';
import PlatformName from '../platformName/index.jsx';
import ShowModal from '../showModal/index.jsx';
import { Tabs, MessageBox, Steps, Loading } from 'element-react';
import TableNavChange from '../tableNavChange/tableNavChange.jsx';
import MyLoading from '../showLoading/showLoading.jsx';
import $ from 'jquery';
import { batchDistributionRequest, ImageSearchProductRequest, LoadProductSkuMappingV2Request, loadSupplierProduct } from '../../utils/api.js';
import { withRouter } from 'react-router-dom';
import SkuMappingsModule from '../skuMappingsModule/index.jsx';
import { huoyuanLink } from '../../utils/index.js';
import { otherExposureReport } from '../../utils/alibabareport.js';


class ChangeProductsModuleV2 extends React.Component {
    constructor(props) {
        super(props);
        const changeSupplierProduct = props.changeSupplierProduct;//更换货源的的商品;
        if (changeSupplierProduct) {
            changeSupplierProduct.SourcePlatform = !changeSupplierProduct.SourcePlatform ? 'AlibabaZhuKe' : changeSupplierProduct.SourcePlatform;
        }
        this.state = {
            isLoading: false,
            loadingTitle: '',
            isShowDailog: props.showModal,
            isShowWarnText: false,
            confrimChangeProduct: false,
            isShowChangeProduct: false,
            hasLoadBorder: false,
            noticeText: "",
            selectProduct: null,//选择的商品
            selectedShopProduct: props.selectedShopProduct,
            selectProductSkuId: props.selectProductSkuId,//选择了哪个店铺商品的sku的下拉框。（选择1688商品sku框）
            supplierProduct: null,//供应商商品
            supplierProductSkuList: [],//供应商商品sku
            TargetShopPt: '',
            TargetShopId: '',
            activeId: props.activeSearchNavId ? props.activeSearchNavId : 0,
            changeProduct: null,
            changeSameProduct: null,
            changeSearchNavs: [
                { id: 0, value: "", title: "链接关联货源", active: false, },
                { id: 1, value: "", title: "找同款关联", active: false, },
            ],
            salesCntSort: 0,//同款货源推荐销量从高到底 排序
            minPriceSort: 0,//价格  排序
            hideTTHelp: false,
            supplierProductList: [],// 找同款商品列表
            selectedShopProductImgSrc: props.selectedShopProductImgSrc,
            isSupplierProductList: true,
            selectProductId: props.selectProductId,
            title: props.title ? props.title : '更换货源',
            selectSourcePlatformNav: 'AlibabaZhuKe',
            isTempRelevanceProduct: props.isTempRelevanceProduct,//提示是否临时替换货源
            isOnlyOrderDialog: false,//更换货源时，是否针仅对当前订单保存代销关系
            changeSupplierProduct: changeSupplierProduct,//更换货源的的商品
            relationData: null,//代销数据
            sureMapBtnName: props.sureMapBtnName ? props.sureMapBtnName : '选择',
            // 关联货源加载状态
            isLoadingProductSkuMapping: false,
            orderItemCode: props.orderItemCode,
            orderCode: props.OrderCode,
            isChangeSp: props.isChangeSp,
            isSameChangeSp: false
        };
    }
    componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。

        var shopInfo = getLoginShopInfo();
        if (shopInfo.loginShopId == "" || shopInfo.loginShopPlatformType == "") {
            var setIntervalTimer = setInterval(() => {
                shopInfo = getLoginShopInfo();
                if (shopInfo.loginShopId != "" && shopInfo.loginShopPlatformType != "") {
                    this.setState({
                        TargetShopId: shopInfo.loginShopId,
                        TargetShopPt: shopInfo.loginShopPlatformType,
                    })
                    clearInterval(setIntervalTimer);
                }
            }, 500)
        }
        var activeId = this.state.activeId;
        var changeSearchNavs = this.state.changeSearchNavs;

        setTimeout(() => {
            changeSearchNavs.forEach((item, index) => {
                item.active = false;
                if (item.id == activeId) {
                    item.active = true;
                }
            })
            this.setState({ changeSearchNavs })
        }, 500)

    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        if (props.showModal != this.state.isShowDailog && props.showModal == true) {
            let activeId = props.activeSearchNavId ? props.activeSearchNavId : 0;
            let changeSearchNavs = this.state.changeSearchNavs;
            const changeSupplierProduct = props.changeSupplierProduct;//更换货源的的商品;
            if (changeSupplierProduct) {
                changeSupplierProduct.SourcePlatform = !changeSupplierProduct.SourcePlatform ? 'AlibabaZhuKe' : changeSupplierProduct.SourcePlatform;
            }
            var shopInfo = getLoginShopInfo();
            this.setState({
                changeSupplierProduct: changeSupplierProduct,//更换货源的的商品
                TargetShopId: shopInfo.loginShopId,
                TargetShopPt: shopInfo.loginShopPlatformType,
                isShowDailog: props.showModal,
                selectedShopProduct: props.selectedShopProduct,
                selectProductSkuId: props.selectProductSkuId,
                activeId: activeId,
                isTempRelevanceProduct: props.isTempRelevanceProduct,
                selectSupplierProductId: props.selectedSupplierProductId,
                title: props.title ? props.title : '更换货源',
                skuMappingsModuleDailog: false,//如果是重新打开，对应规格映射弹窗关闭
                orderItemCode: props.orderItemCode,
                orderCode: props.orderCode,
            })
            const relationData = props.relationData;


            changeSearchNavs.forEach((item, index) => {
                item.active = false;
                if (item.id == activeId) {
                    item.active = true;
                }
                if (item.id == 0) {
                    this.setState({ supplierProductList: [] })
                }
            })
            this.setState({ changeSearchNavs });
            if (props.showModal) {
                this.setState({
                    selectProductId: props.selectProductId,
                    selectedShopProductImgSrc: props.selectedShopProductImgSrc,
                    isChangeSp: props.isChangeSp,
                }, () => {
                    if (relationData) {
                        this.initData(relationData)
                    } else {
                        this.getSelectProductInfo();  //获取选中商品详细详情
                    }
                })
            }
            if (activeId == 1 && props.showModal) {
                this.getSupplierProductList(props.selectedShopProductImgSrc);
            }
        }
    }

    //切换 链接关联货源  找同款关联 导航
    changeNav = (e) => {
        this.setState({
            activeId: e.id
        })
        if (e.id == 1) {
            otherExposureReport("tktj");
            this.getSupplierProductList(this.state.selectedShopProductImgSrc);

        }
    }
    getSupplierProductList(selectedShopProductImgSrc) { //获取同步商品列表
        if (!selectedShopProductImgSrc) {
            selectedShopProductImgSrc = this.state.selectedShopProductImgSrc
        }
        let sourcePlatform = $("input[name=selectSourcePlatform]:checked").val()
        if (!sourcePlatform) {
            sourcePlatform = this.state.selectSourcePlatformNav
        } else {
            this.state.selectSourcePlatformNav = sourcePlatform
        }
        this.state.needBindBuyerShop = ''
        this.setState({ isLoading: true, loadingTitle: '获取商品中...' });
        this.translateImgToBase64(selectedShopProductImgSrc, 2, (base64) => {
            this.setState({ supplierProductList: [] }, async () => {
                let data = {
                    SourcePlatform: sourcePlatform,
                    Images: [base64]
                }
                const res = await ImageSearchProductRequest(data);
                this.setState({ isLoading: false });
                if (res.Success == true) {
                    let resultData = res.Data || [];
                    this.setState({
                        supplierProductList: resultData,
                        isSupplierProductList: resultData.length == 0
                    })
                }
                if (res.ErrorCode == 'TAOTE_AUTH_INVALID' || res.ErrorCode == 'ALIBABA_AUTH_EXPIRED') {
                    this.state.needBindBuyerShop = res.ErrorCode;
                    this.setState({})
                    return;
                }
            })
        }, (e) => {
            this.setState({ isLoading: false });
            messageShow("图片地址无效", "info");
        })

    }

    /**图片压缩转换 */
    translateImgToBase64(url, rate, callback, err) {
        var that = this;
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        var img = new Image  //通过构造函数绘制图片实例
        img.crossOrigin = 'Anonymous'  //处理图片跨域问题
        img.onload = function () {   //该加载过程为异步事件，请先确保获取完整图片
            var targetWidth = img.width / rate;
            var targetHeight = img.height / rate;
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            context.drawImage(img, 0, 0, img.width, img.height, 0, 0, targetWidth, targetHeight)
            var URLData = canvas.toDataURL('image/jpeg');
            var size = that.showSize(URLData);
            if (size > 300) {
                that.translateImgToBase64(URLData, rate, callback, err);
                return;
            }
            callback(URLData);
            canvas = null
        }
        if (err)
            img.onerror = err;
        img.src = url
    }
    showSize(base64url) {
        //把头部去掉
        var str = base64url.replace('data:image/png;base64,', '');
        // 找到等号，把等号也去掉
        var equalIndex = str.indexOf('=');
        if (str.indexOf('=') > 0) {
            str = str.substring(0, equalIndex);
        }
        // 原来的字符流大小，单位为字节
        var strLength = str.length;
        // 计算后得到的文件流大小，单位为字节
        var fileLength = parseInt(strLength - (strLength / 8) * 2);
        // 由字节转换为kb
        var size = "";
        size = (fileLength / 1024).toFixed(2);
        var sizeStr = size + ""; //转成字符串
        var index = sizeStr.indexOf("."); //获取小数点处的索引
        var dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
        if (dou == "00") { //判断后两位是否为00，如果是则删除00                
            return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
        }
        return size;
    }

    inputTextareaByChangeProduct = () => {
        var setTimes = this.state.setTimes;
        if (setTimes != null) {
            clearTimeout(setTimes);
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }
        else {
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }

        this.setState({
            hideTTHelp: $('#textareaByChangeProductId').val().length > 0
        })

    }
    async loadSupplierProductByUrl(url) {
        var that = this;
        this.setState({
            changeProduct: null
        });

        if (url == null || url == '') {
            return;
        }
        var data = {};

        let supplierProducts = matchSupplierProduct(url);
        // if(systemConfig.isZk1() == false && systemConfig.isZk5() == false){
        //supplierProducts = supplierProducts.filter(x => x.sourcePlatform != 'TaoteZhuKe')
        // }
        if (supplierProducts.length == 0) {
            that.setState({
                noticeText: '请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或者商品ID)',
                isShowWarnText: true
            });
            return;
        }
        data.SupplierProductId = supplierProducts[0].supplierProductId
        data.SourcePlatform = supplierProducts[0].sourcePlatform

        that.setState({
            hasLoadBorder: true,
            noticeText: "正在抓取商品信息..",
            isShowLoadAction: true,
            isShowWarnText: false
        })

        if (supplierProducts[0].sourcePlatform == 'TaoteZhuKe' && !supplierProducts[0].supplierProductId) {
            const matchTaoteLinkRequestData = { Links: [supplierProducts[0].link] }
            const res = await batchDistributionRequest.MatchTaoteLink(matchTaoteLinkRequestData)
            if (res.Success) {
                if (res.Data.List && res.Data.List.length > 0) {
                    data.SupplierProductId = res.Data.List[0].Item2
                }
            }
            if (!data.SupplierProductId) {
                that.setState({
                    noticeText: '淘口令已失效',
                    isShowWarnText: true
                });
                return;
            }
        }
        requests({
            url: "/Product/LoadSupplierProduct",
            data: data,
            success: function (res) {
                that.setState({ isShowLoadAction: false });


                if (res.Success) {
                    var supplierProduct = res.Data.AlibabaProduct;

                    //遍历sku获取价格区间,供应商sku列表
                    var priceArr = [];
                    var supplierProductSkuList = [];
                    for (let i = 0; i < supplierProduct.Skus.length; i++) {
                        priceArr.push(supplierProduct.Skus[i].ConsignPrice);
                        var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
                        var color = '';
                        var size = '';

                        for (let n = 0; n < attrArr.length; n++) {
                            if (n == 0) {
                                color = attrArr[n].AttributeValue;
                            } else {
                                size = attrArr[n].AttributeValue;
                            }
                        }
                        supplierProduct.Skus[i].Color = color
                        supplierProduct.Skus[i].Size = size
                        supplierProductSkuList.push({
                            label: color + size,
                            value: supplierProduct.Skus[i].SkuId
                        });
                    }
                    priceArr.sort();
                    supplierProduct.SourcePlatform = !supplierProduct.SourcePlatform ? 'AlibabaZhuKe' : supplierProduct.SourcePlatform

                    var changeProduct = {
                        ImageUrl: supplierProduct.Images[0],
                        Subject: supplierProduct.Subject,
                        PriceArr: priceArr,
                        SupplyStock: supplierProduct.SupplyStock,
                        Text: '',
                        Status: supplierProduct.Status,
                        SupplierLoginId: supplierProduct.SupplierLoginId,
                        platformName: supplierProduct.SourcePlatform,
                        SupportEncryptChannelDesc: supplierProduct.SupportEncryptChannelDesc,
                        PickupAssr: supplierProduct.PickupAssr
                    }

                    that.setState({
                        changeProduct: changeProduct,
                        supplierProduct: supplierProduct,
                        supplierProductSkuList: supplierProductSkuList,
                        selectSupplierLoginId: supplierProduct.SupplierLoginId,
                        selectSupplierProductId: supplierProduct.ProductId,
                        selectSourcePlatform: supplierProduct.SourcePlatform
                    }, () => {
                        $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                            if ($(item).val() != "") {
                                $(item).addClass("active")
                            }
                        })
                    });
                } else {
                    that.setState({
                        noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
                        isShowWarnText: true,
                        showNotFoundSupplierProductError: true,
                    });
                }
            },
        });
    }
    relevanceProducFromChange = (item) => {
        var that = this;
        if (!this.state.selectProduct || !this.state.selectProduct.PlatformId) {
            messageShow("同步店铺商品信息超时，请在重新同步完成后再进行关联", "warning");
            return;
        }
        if (this.state.changeProduct == null) {
            messageShow("未获取到货源商品信息，请输入正确格式的货源链接", "warning");
            return;
        }
        const supplierProduct = this.state.supplierProduct
        if (supplierProduct.SourcePlatform == 'TaoteZhuKe') {
            if (that.state.relationApiData.Relation.length > 0) {
                messageShow("淘特货源不支持多货源", "error");
                return;
            }
        }
        const exists = that.state.relationApiData.SupplierProducts.findIndex(x => x.SourcePlatform == supplierProduct.SourcePlatform && supplierProduct.ProductId == x.ProductId)
        if (exists == -1)
            that.state.relationApiData.SupplierProducts.push(supplierProduct)

        if (that.state.relationApiData.SupplierProducts.length > 20) {
            messageShow('最多添20个货源', 'error');
            return;
        }
        if (typeof this.props.saveSureSupplierProduct == 'function' && this.props.isReturnSelectSupplierProduct == 1) {
            this.closeShowModal()
            this.props.saveSureSupplierProduct(supplierProduct)
        } else {
            this.showSkuMapping()
            this.setState({});
        }
    }

    //关闭确认更换货源弹窗
    closeChangeProduct = (type) => {
        this.setState({
            supplierProductList: [],
            isSupplierProductList: false,
            isShowChangeProduct: false,
            isShowDailog: false,
            changeWidth: 900,
            selectProduct: null,
            changeProduct: null,
            isOnlyOrderDialog: false,
            tempPlatformOrderId: null,
            isTempRelevanceProduct: false,
            isLoadingProductSkuMapping: false,
            isSameChangeSp: false
        });
        this.props.closeChangeProductsModule();
    }

    closeShowModal = () => {
        this.setState({ isShowDailog: false, supplierProductList: [], isSupplierProductList: false, isSameChangeSp: false });
        this.props.closeChangeProductsModule();
    }

    orderbyChange = (sortName) => {
        let sortType = this.state[sortName] == 0 ? 1 : 0;
        $("#" + sortName).removeClass("active1").removeClass("active0").addClass("active" + sortType);
        this.setState({ [sortName]: sortType });
        let supplierProductList = this.state.supplierProductList;

        if (sortName == "minPriceSort") {
            if (sortType == 0) {
                supplierProductList = supplierProductList.sort(function (a, b) { return b['Price'] - a['Price']; });
            } else {
                supplierProductList = supplierProductList.sort(function (a, b) { return a['Price'] - b['Price']; });
            }
        }
        this.setState({
            supplierProductList
        })

    }

    toMyAuthPage(errorCode) {
        let fromaction;
        if (errorCode == 'ALIBABA_AUTH_EXPIRED') {
            fromaction = 'alibaba_auth_expire'
        }
        else if (errorCode == 'TAOTE_AUTH_INVALID') {
            fromaction = 'taote_auth_expire'
        }
        const path = { pathname: '/myAuth', state: { from_action: fromaction } }
        this.props.history.push(path);
    }

    chooseMapProductSku = async (item) => {
        const hasTaoteSupplierProduct = !systemConfig.zhukeTaoteAuth && item.SourcePlatform == 'TaoteZhuKe';
        const hasAliSupplierProduct = !systemConfig.zhukeAlibabaAuth && (item.SourcePlatform == 'AlibabaZhuKe' || !item.SourcePlatform);
        if (hasAliSupplierProduct) {
            this.sourcePlatformAuthDailog('AlibabaZhuKe');
            return;
        }
        else if (hasTaoteSupplierProduct) {
            this.sourcePlatformAuthDailog('TaoteZhuKe');
            return;
        }
        if (this.state.relationApiData && this.state.relationApiData.SupplierProducts.length >= 20) {
            messageShow('最多关联20个货源', 'error');
            return
        }
        if (item.SourcePlatform == 'TaoteZhuKe') {
            if (this.state.relationApiData && this.state.relationApiData.Relation.length > 0) {
                messageShow("淘特货源不支持多货源", "error");
                return;
            }
        }


        // await this.getSelectProductInfo();
        await this.getSelectSupplierProductInfo(item);//获取同款商品详情
        this.setState({
            isLoading: false,
            loadingTitle: '',
        })

    }
    /**淘特授权过期跳转对话框 */
    sourcePlatformAuthDailog = async (sourcePlatform) => {
        let str = '1688和淘特'
        let fromaction;
        if (sourcePlatform == 'AlibabaZhuKe') {
            str = '1688'
            fromaction = 'alibaba_auth_expire'
        } else if (sourcePlatform == 'TaoteZhuKe') {
            str = '淘特'
            fromaction = 'taote_auth_expire'
        }
        console.log('this =>', this);
        const action = await MessageBox.msgbox({
            title: '授权提示',
            message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>{str}货源授权</span>，您未获得{str}授权或者授权失效，请先进行授权</span>,
            type: 'info',
            showCancelButton: false,
            confirmButtonText: '去授权'
        })
        if (action == 'confirm') {
            const path = { pathname: '/myAuth', state: { from_action: fromaction } }
            console.log('this =>', this);
            this.props.history.push(path);
        }
    }

    getSelectProductInfo = async () => {
        const data = {
            ShopId: this.state.TargetShopId,
            ProductId: this.state.selectProductId,
            OrderItemCode: this.state.orderItemCode,
            OrderCode: this.state.orderCode,
        };
        this.setState({
            selectProduct: null,
            noticeText: '获取信息中...',
            isLoadingProductSkuMapping: false,
        });
        const res = await LoadProductSkuMappingV2Request(data);
        this.setState({
            isLoadingProductSkuMapping: true,
        })
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
            this.setState({ noticeText: '请求超时，请重试。' });
            return;
        }
        this.setState({ noticeText: '' });
        if (res.Success) {
            this.initData(res.Data)
        } else {
            messageShow("获取商品信息失败" + res.Message, "error");
        }
    }

    initData = (relationApiData) => {
        const product = relationApiData.ProductFx;
        relationApiData.SupplierProducts = relationApiData.SupplierProducts || []
        relationApiData.Relation = relationApiData.Relation || []

        relationApiData.Relation.forEach(x => {
            x.SkuMappings = x.SkuMappings || []
            x.SkuMappings.forEach(mapping => {
                mapping.SourcePlatform = !mapping.SourcePlatform ? 'AlibabaZhuKe' : mapping.SourcePlatform
                mapping.MappingCount = mapping.MappingCount == 0 ? 1 : mapping.MappingCount//如果发现后台返回值的mappingcount为0，改为1
            })
        })

        relationApiData.SupplierProducts.forEach(supplierProduct => {
            supplierProduct.SourcePlatform = !supplierProduct.SourcePlatform ? 'AlibabaZhuKe' : supplierProduct.SourcePlatform
        })

        if (this.state.changeSupplierProduct) {
            const changeSupplierProduct = this.state.changeSupplierProduct;//需要替换的货源
            const hasIndex = relationApiData.SupplierProducts.findIndex(x => x.SourcePlatform == changeSupplierProduct.SourcePlatform && x.ProductId == changeSupplierProduct.ProductId)
            if (hasIndex != -1) {
                // relationApiData.SupplierProducts.splice(hasIndex, 1)
                relationApiData.Relation = relationApiData.Relation.filter(x => x.SourcePlatform != changeSupplierProduct.SourcePlatform || x.SupplierProductId != changeSupplierProduct.ProductId)
            }
        }

        var priceArr = [];
        for (let i = 0; i < product.Skus.length; i++) {
            priceArr.push(product.Skus[i].SalePrice);
            product.Skus[i].SupplierSkuList = null;
        }
        priceArr.sort();
        product.PriceArr = priceArr;
        this.setState({
            selectProduct: product,
            relationApiData: relationApiData,
            selectPlatformTypeRelevance: product.PlatformType,
            isLoadingProductSkuMapping: true
        });
    }

    getSelectSupplierProductInfo = async (item) => {
        var data = {
            SupplierProductId: item.ProductId,
            SourcePlatform: item.SourcePlatform
        };
        this.setState({ isLoading: true })
        const res = await loadSupplierProduct(data)
        this.setState({ isShowLoadAction: false, isLoading: false, });
        if (res.Success) {
            var supplierProduct = res.Data.AlibabaProduct;

            //遍历sku获取价格区间,供应商sku列表
            var priceArr = [];
            var supplierProductSkuList = [];
            for (let i = 0; i < supplierProduct.Skus.length; i++) {
                priceArr.push(supplierProduct.Skus[i].ConsignPrice);
                var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
                var color = '';
                var size = '';

                for (let n = 0; n < attrArr.length; n++) {
                    if (n == 0) {
                        color = attrArr[n].AttributeValue;
                    } else {
                        size = attrArr[n].AttributeValue;
                    }
                }

                supplierProduct.Skus[i].Color = color
                supplierProduct.Skus[i].Size = size
                supplierProductSkuList.push({
                    label: color + size,
                    value: supplierProduct.Skus[i].SkuId
                });
            }
            priceArr.sort();

            var changeProduct = {
                ImageUrl: supplierProduct.Images[0],
                Subject: supplierProduct.Subject,
                PriceArr: priceArr,
                SupplyStock: supplierProduct.SupplyStock,
                Text: '',
                Status: supplierProduct.Status,
                SupplierLoginId: supplierProduct.SupplierLoginId,
                platformName: supplierProduct.SourcePlatform,
            }

            if (supplierProduct.SupportEncryptChannelDesc != null) {
                supplierProduct.SupportEncryptOrder = supplierProduct.SupportEncryptChannelDesc.includes("Taobao")
            } else if (supplierProduct.SupportEncryptChannel) {
                supplierProduct.SupportEncryptOrder = supplierProduct.SupportEncryptChannel.indexOf("thyny") > -1
            }

            supplierProduct.SourcePlatform = !supplierProduct.SourcePlatform ? 'AlibabaZhuKe' : supplierProduct.SourcePlatform

            const exists = this.state.relationApiData.SupplierProducts.findIndex(x => x.SourcePlatform == supplierProduct.SourcePlatform && supplierProduct.ProductId == x.ProductId)
            if(this.state.changeSupplierProduct || this.state.isSameChangeSp) {
                const sProductId = this.state.changeSupplierProduct.ProductId;
                const sIndex = this.state.relationApiData.SupplierProducts.findIndex(x => x.ProductId == sProductId && sProductId != item.ProductId)

                if (sIndex > -1) {
                    this.state.relationApiData.SupplierProducts.splice(sIndex, 1, supplierProduct)
                } else {
                    this.state.relationApiData.SupplierProducts.push(supplierProduct)
                }
            } else if (exists == -1) {
                this.state.relationApiData.SupplierProducts.push(supplierProduct)
            } else if (exists > -1) {
                this.state.relationApiData.SupplierProducts.splice(exists, 1, supplierProduct)
            }
            
            if (typeof this.props.saveSureSupplierProduct == 'function' && this.props.isReturnSelectSupplierProduct == 1) {
                this.closeShowModal()
                this.props.saveSureSupplierProduct(supplierProduct)
            } else {
                this.showSkuMapping()
                this.setState({
                    changeSameProduct: changeProduct,
                    supplierProduct: supplierProduct,
                    supplierProductSkuList: supplierProductSkuList,
                    selectSupplierLoginId: supplierProduct.SupplierLoginId,
                    selectSupplierProductId: supplierProduct.ProductId,
                }, () => {
                    $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                        if ($(item).val() != "") {
                            $(item).addClass("active")
                        }
                    })
                });
            }
        } else {
            // messageShow("错误信息：" + res.Message, 'error');
            this.setState({
                noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
                isShowWarnText: true,
                showNotFoundSupplierProductError: true,
            });
        }

    }
    closeNotFoundAlibabaSupplierProductErrorDailog() {
        this.state.showNotFoundSupplierProductError = false
        this.state.showNotFoundAlibabaSupplierProductError = false
        this.setState({})
    }

    showSkuMapping(product) {
        this.setState({
            skuMappingsModuleDailog: true,
            skuMappingSelectProduct: product,
        })
    }
    closeSkuMappingsModule = () => {
        const supplierProducts = (this.state.relationApiData && this.state.relationApiData.SupplierProducts) || [];
        if (this.state.supplierProduct && supplierProducts.length > 0) {
            const index = supplierProducts.findIndex(x => x.ProductId == this.state.supplierProduct.ProductId)
            if (index > -1) {
                supplierProducts.splice(index, 1)
            }
        }

        this.setState({
            skuMappingsModuleDailog: false,
            skuMappingSelectProduct: null,
        })
    }
    sureSkuMapping = async (data) => {
        if (this.state.isTempRelevanceProduct == 1) {
            this.props.tempChangeProductSaveSure(data)
        } else {
            this.setState({ isLoading: true })
            const res = await batchDistributionRequest.RelateProductV2(data)
            this.setState({ isLoading: false })
            if (res.Success) {
                messageShow("关联成功，可到代销商品中查看。", 'success');
                this.closeSkuMappingsModule()
                this.closeShowModal()
                this.props.sureRelevanceRequest(data)
            } else {
                messageShow('关联规格失败：' + res.Message, 'error')
            }
        }
    }

    onChangeSupplierProduct = (data) => {
        this.setState({
            isSameChangeSp: true,
            skuMappingsModuleDailog: false,
            changeSupplierProduct: data.changeSupplierProduct
        })
    }

    render() {
        return (
            <ShowModal
                showLeftTopBtn={true}
                width={900}
                showModal={this.state.isShowDailog}
                titleName={this.state.title}
                skin={"changeProductsWrap"}
                hideBtn={true}
                cancelDailog={this.closeShowModal} //取消按钮回调函数

            >

                <div className="showModalWrap-box-commonContent changeProductsWrap-commonContent scroll-x" style={{ marginBottom: '20px' }}>
                    <div className="showModalWrap-commonContent-item">

                        <div className='tagStatus tagWarn tagStatusWrap' style={{ marginBottom: '10px' }}>
                            <span style={{ color: "#666" }}>{this.state.isChangeSp ? "同款货源替换" : "关联货源"}  <i className='iconfont icon-xiangxia'></i> 规格匹配 <i className='iconfont icon-xiangxia' style={{ fontSize: '15px' }}></i> 订单自动回流采购</span>
                            <div className='iconfont icon-tips'>
                                <div className='icon-tips-content' style={{ marginTop: '-150px' }}>
                                    <span>1、关联或更换货源时，注意货源的起批量，避免因起批量不足导致不能正常采购。</span>
                                    <span>2、关联或更换货源后，请进行规格匹配，匹配后店铺商品被买家下单时，将会按您匹配的货源规格进行采购，并同步发货和物流信息;</span>
                                    <span>3、您和供应商任意一方修改规格名/删除规格，都会导致匹配关系失效，需要重新进行匹配规格。</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='myStepWrap'>
                        <ul className='myStepWrap-steps'>
                            <li className='myStepWrap-steps-item' style={{ flex: 1.3 }}>
                                <div className='myStepWrap-steps-item-up'>
                                    <span className='steps-num'>1</span>
                                    <span className='steps-title'>{this.state.isChangeSp ? "同款货源替换" : "关联货源"}</span>
                                    <span className='steps-line'></span>
                                </div>
                                <div className='myStepWrap-steps-item-down'>
                                    {this.state.isChangeSp ? <span>将原货源替换成同款货源</span> :
                                        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span>店铺商品均可关联多件1688</span>
                                            <span>商品</span>
                                        </span>
                                    }
                                </div>
                            </li>

                            <li className='myStepWrap-steps-item' style={{ flex: 1.3 }}>
                                <div className='myStepWrap-steps-item-up'>
                                    <span className='steps-num'>2</span>
                                    <span className='steps-title'>匹配规格</span>
                                    <span className='steps-line'></span>
                                </div>
                                <div className='myStepWrap-steps-item-down'>
                                    {this.state.isChangeSp ?
                                        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span>将原货源的规格替换成同款货</span>
                                            <span>源的一个规格</span>
                                        </span> :
                                        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span>店铺商品—个规格可以关联多</span>
                                            <span>个1688货源商品的多个规格</span>
                                        </span>
                                    }
                                </div>
                            </li>
                            <li className='myStepWrap-steps-item'>
                                <div className='myStepWrap-steps-item-up'>
                                    <span className='steps-num'>3</span>
                                    <span className='steps-title'>采购下单</span>
                                </div>
                                <div className='myStepWrap-steps-item-down' style={{ left: '-35px' }}>
                                    <span>店铺商品有订单后,将会按已</span>
                                    <span>匹配的货源规格进行采购下单</span>
                                </div>
                            </li>
                        </ul>

                    </div>
                    <div>

                        <div className='tagProductWrap' style={{ backgroundColor: '#f0f7ff' }}>
                            <div className='tagProductWrap-title' style={{ borderBottom: 'unset', paddingBottom: '5px' }}>
                                {this.state.isChangeSp
                                    ? <span>原货源：</span> :
                                    <span>
                                        <span>店铺商品ID：</span>
                                        <span>{this.state.selectProduct == null ? "" : this.state.selectProduct.PlatformId}</span>
                                        <span style={{ marginLeft: '10px' }}>已关联<span className='defColor'>{this.state.relationApiData && this.state.relationApiData.Relation.length}</span>个货源<span className='errorColor'>（最多关联20个货源）</span></span>
                                    </span>
                                }
                            </div>
                            {
                                this.state.isLoadingProductSkuMapping ?
                                    this.state.selectProduct && this.state.selectProduct.PlatformId ?
                                        <div className="productShow table-product">
                                            <div className="productShow-imgWrap">
                                                {
                                                    this.state.isChangeSp ?
                                                        <img src={this.state.selectedShopProductImgSrc} />
                                                        :
                                                        <img src={this.state.selectProduct == null ? "" : this.state.selectProduct.ImageUrl ? this.state.selectProduct.ImageUrl : this.state.selectProduct.PicURI ? this.state.selectProduct.PicURI : ''} alt="" />
                                                }
                                            </div>
                                            <ul style={{ justifyContent: 'space-between', height: '50px' }}>
                                                <li title="商品标题">
                                                    {
                                                        this.state.isChangeSp ? <span>{this.state.changeSupplierProduct.Subject}</span> :
                                                            <span>{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</span>
                                                    }
                                                </li>
                                                {
                                                    this.state.isChangeSp ? null : <li title="价格">
                                                        <span className='dangerColor'>售价：￥{this.state.selectProduct == null || this.state.selectProduct.PriceArr == null ? "" : this.state.selectProduct.PriceArr[0]}起</span>
                                                    </li>
                                                }
                                                {
                                                    this.state.isChangeSp ? <li style={{ color: '#999' }} title="供应商旺旺">供应商旺旺：<span>{this.state.changeSupplierProduct.SupplierLoginId}</span></li> : null
                                                }
                                            </ul>
                                        </div>
                                        : <div style={{ color: '#ff0000', height: '30px', lineHeight: '30px', padding: '0 10px' }}>
                                            <div>同步商品失败，请<span className='defColor hover' onClick={() => { this.getSelectProductInfo() }}>重试</span></div>
                                        </div>
                                    :
                                    <Loading isLoading={!this.state.isLoadingProductSkuMapping}>
                                        <div className='tagProductWrap' style={{ backgroundColor: '#f0f7ff', height: '30px', }}></div>
                                    </Loading>
                            }
                        </div>

                    </div>
                    <TableNavChange distributionStatus={this.state.changeSearchNavs} noShowNum={true} changeNav={this.changeNav} />
                    {
                        this.state.activeId == 0 ?
                            <div>
                                <div>
                                    <div>
                                        {
                                            <div className="showModalWrap-commonContent-item" style={{ position: 'relative' }}>
                                                <textarea className='link-textarea' placeholder='请输入1688货源链接' id="textareaByChangeProductId" style={{ overflow: "hidden", width: "100%", padding: "5px", height: '50px' }} onInput={() => this.inputTextareaByChangeProduct()} onBlur={(e) => this.loadSupplierProductByUrl(e.target.value)}></textarea>
                                                {/* {
                          !this.state.hideTTHelp ?
                            <a className='showModalWrap-help' href='https://docs.qq.com/doc/DYm5seUFNaFdPZ1ls' target='_blank'>如何获取淘特口令上货？</a> : null
                        } */}
                                            </div>
                                        }

                                        {/* <div className="showModalWrap-commonContent-item showModalWrap-commonContent-loadWrap" style={this.state.isShowWarnText ? { display: 'flex' } : { display: 'none' }}>
                      <div style={this.state.isShowLoadAction ? { display: 'inline' } : { display: 'none' }}><span className='loadmore'></span></div>
                      {
                        this.state.isShowWarnText ?
                          <div className='noticeText'>
                            <i className='iconfont icon-shanchu dangerColor'></i>{this.state.noticeText}</div> :
                          <span className='noticeText02'>{this.state.noticeText}</span>
                      }
                    </div> */}
                                        <div className='platformWrap' style={this.state.changeProduct == null ? { display: 'flex' } : { display: 'none' }}>
                                            <span>支持平台：</span>
                                            <PlatformName platformType={'Alibaba'} iconSize={"smallIcon"} />
                                            {
                                                // <PlatformName platformType={'Taote'} iconSize={"smallIcon"} />
                                            }
                                        </div>

                                        <div className="showModalWrap-commonContent-item productShow showModalWrapProductShow" style={this.state.changeProduct != null ? { display: 'flex' } : { display: 'none' }}>
                                            <span className='productShow-title'>货源信息</span>
                                            <div className='productShow-content'>
                                                <div className='productShow-content-img'>
                                                    <img src={this.state.changeProduct != null ? this.state.changeProduct.ImageUrl : ''}></img>
                                                </div>
                                                <ul className='productShow-content-sku'>
                                                    <li onClick={() => { huoyuanLink(this.state.supplierProduct) }} className='hover' style={{ color: '#3aadff' }}>{this.state.changeProduct != null ? this.state.changeProduct.Subject : ''}</li>
                                                    <li className='dangerColor'>¥{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[0] : ''}
                                                        ~{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[this.state.changeProduct.PriceArr.length - 1] : ''}
                                                        {
                                                            this.state.changeProduct && this.state.changeProduct.PickupAssr ? <span className='productShow-content-sku-tag popoverCommon' style={{ marginLeft: '16px' }}>
                                                                <span>{this.state.changeProduct.PickupAssr}h晚揽必赔</span>
                                                                <div className='popoverCommon-warn' style={{ bottom: '24px', color: '#000', left: '0px', fontSize: '12px' }}>
                                                                    <div>1. 什么是晚揽必赔？</div>
                                                                    <div>例如：24小时晚揽必赔，是指：商家承诺在分销商支付后24小时内回传物流揽收信息。若商家未履行，商家会理赔。48小时同理。</div>
                                                                    <div style={{ marginTop: '12px' }}>2. 承诺24/48小时晚揽必赔的商品，没在</div>
                                                                    <div>24/48小时揽收是否需要申请理赔？</div>
                                                                    <div style={{ marginBottom: '12px' }}>不用申请，系统会自动理赔。</div>
                                                                    <a style={{ color: '#17aef1' }} href='https://peixun.1688.com/space/l2Amo48BwAwpDGdb/detail/N7dx2rn0JbZ9pAeeigPR7x9RJMGjLRb3' target="_blank">{'查看详情>>'}</a>
                                                                </div>
                                                            </span> : null
                                                        }
                                                    </li>
                                                    <li>库存：{this.state.changeProduct != null ? this.state.changeProduct.SupplyStock : ''}</li>
                                                    <li>{
                                                        (this.state.changeProduct != null && this.state.changeProduct.SupportEncryptChannelDesc != null) ?
                                                            <div>
                                                                {isNotNull(this.state.changeProduct.SupportEncryptChannelDesc) ? "支持密文下单渠道:" : "支持密文下单渠道:--"}
                                                                {this.state.changeProduct.SupportEncryptChannelDesc.map((item) =>
                                                                    <label style={{ marginLeft: "3px" }}>
                                                                        <PlatformName platformType={item} iconSize={"tinyIcon"} isHidePatformName={true} /></label>
                                                                )}
                                                            </div> : null
                                                    }
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="showModalWrap-box-commonfooter">
                                    <span style={(this.state.changeProduct != null && this.state.isLoadingProductSkuMapping) ? { cursor: "pointer", backgroundColor: "#5584ff", border: '1px solid #5584ff' } :
                                        { cursor: "not-allowed", backgroundColor: "#ccc", border: '1px solid #ccc' }}
                                        onClick={() => this.relevanceProducFromChange()} className="showModalWrap-box-footer-btn">{this.state.changeSupplierProduct == null ? '确认关联' : '确认更换'}</span>
                                    <span onClick={() => this.closeChangeProduct('changeStatus')} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                                </div>
                            </div>
                            :
                            <div className='syncProductWrap'>
                                <div >
                                    <table className="table02">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "600px" }}>

                                                    <span>产品详情</span>
                                                    <div style={{ display: 'inline-flex' }}>
                                                        {/* <div>
                              <input name="selectSourcePlatform" type="radio" value="" checked={!this.state.selectSourcePlatform ? true : false} onChange={(e) => this.getSupplierProductList()}></input>
                              <span>全部</span>
                            </div> */}

                                                        <div>
                                                            <input name="selectSourcePlatform" type="radio" value="AlibabaZhuKe" checked={this.state.selectSourcePlatformNav == 'AlibabaZhuKe' ? true : false} onChange={(e) => this.getSupplierProductList()}></input>
                                                            <span>1688</span>
                                                        </div>

                                                        {/* <div>
                              <input name="selectSourcePlatform" type="radio" value="TaoteZhuKe" checked={this.state.selectSourcePlatformNav == 'TaoteZhuKe' ? true : false} onChange={(e) => this.getSupplierProductList()}></input>
                              <span>淘特</span>
                            </div> */}


                                                    </div>

                                                </th>
                                                <th style={{ width: "120px" }}>
                                                    <div onClick={() => this.orderbyChange('minPriceSort')} id="minPriceSort" className='operateWrap'>
                                                        <span className='hover'>价格</span>
                                                        <span className="ph-filtbar-down-leftBtns-icons">
                                                            <i className="icon-down-fill iconfont"></i>
                                                            <i className="icon-down-fill iconfont"></i>
                                                        </span>
                                                    </div>
                                                </th>
                                                <th style={{ width: "120px" }}>操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.supplierProductList.map((item, index) =>
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="productShow table-product">
                                                                <div className="productShow-imgWrap productShow-imgWrap-hover">
                                                                    <img src={item.PicImageUrl} alt="" />
                                                                </div>
                                                                <ul>
                                                                    <li title="商品标题">
                                                                        <span onClick={() => huoyuanLink(item)} className='defColor hover'>
                                                                            {item.Title}
                                                                        </span>
                                                                    </li>
                                                                    <li className='my-select-02-inputWrap-title-right' >
                                                                        <label>
                                                                            <PlatformName className="platformName-wrap" platformType={item.SourcePlatform} iconSize={"tinyIcon"} />
                                                                            <span title={item.SourcePalletDesc} class="my-select-03-expressTemplateWrap-title" style={{ "color": "#f7941f" }}>{item.SourcePallet}</span>
                                                                            {
                                                                                item.PickupAssr ? <span className='productShow-content-sku-tag popoverCommon' style={{ alignItems: 'center' }}>
                                                                                    <span>{item.PickupAssr}h晚揽必赔</span>
                                                                                    <div className='popoverCommon-warn' style={{ bottom: '24px', color: '#000', left: '0px', fontSize: '12px' }}>
                                                                                        <div>1. 什么是晚揽必赔？</div>
                                                                                        <div>例如：24小时晚揽必赔，是指：商家承诺在分销商支付后24小时内回传物流揽收信息。若商家未履行，商家会理赔。48小时同理。</div>
                                                                                        <div style={{ marginTop: '12px' }}>2. 承诺24/48小时晚揽必赔的商品，没在</div>
                                                                                        <div>24/48小时揽收是否需要申请理赔？</div>
                                                                                        <div style={{ marginBottom: '12px' }}>不用申请，系统会自动理赔。</div>
                                                                                        <a style={{ color: '#17aef1' }} href='https://peixun.1688.com/space/l2Amo48BwAwpDGdb/detail/N7dx2rn0JbZ9pAeeigPR7x9RJMGjLRb3' target="_blank">{'查看详情>>'}</a>
                                                                                    </div>
                                                                                </span> : null
                                                                            }
                                                                        </label>
                                                                    </li>
                                                                    <li>
                                                                        {isNotNull(item.SupportEncryptChannel) ? "支持密文下单渠道:" : "支持密文下单渠道:--"}
                                                                        {item.SupportEncryptChannel.map((item) =>
                                                                            <label style={{ marginLeft: "3px" }}>
                                                                                <PlatformName platformType={item} iconSize={"tinyIcon"} isHidePatformName={true} /></label>
                                                                        )}

                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className='dangerColor'>价格：￥{item.Price}</span>
                                                        </td>
                                                        <td>
                                                            <span className='defColor hover' onClick={() => this.chooseMapProductSku(item)}>{this.state.changeProduct ? "确定更换" : this.state.isChangeSp ? "确认替换" : "选择"}</span>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            {
                                                this.state.isSupplierProductList && !this.state.needBindBuyerShop ?
                                                    <tr>
                                                        <td className="noneData" colSpan="20">
                                                            <div className="noneData-wrap">
                                                                <i className="iconfont icon-wushuju"></i>
                                                                <span className="noneData-title">暂无同款数据！</span>
                                                            </div>
                                                        </td>
                                                    </tr> : null
                                            }
                                            {
                                                this.state.needBindBuyerShop ?
                                                    <tr>
                                                        <td className="noneData" colSpan="20">
                                                            <div className="noneData-wrap">
                                                                <span className="noneData-title">当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>
                                                                    {this.state.needBindBuyerShop == 'TAOTE_AUTH_INVALID' ? '淘特' : '1688'}货源授权</span>，
                                                                    您未获得{this.state.needBindBuyerShop == 'TAOTE_AUTH_INVALID' ? '淘特' : '1688'}授权或者授权失效，请先进行授权</span>
                                                                <div style={{ marginTop: '10px' }}>
                                                                    <span className="el-button el-button--primary" onClick={() => this.toMyAuthPage(this.state.needBindBuyerShop)}>前往授权</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr> : null
                                            }
                                        </tbody>
                                    </table>
                                </div>

                                {/* <div className="showModalWrap-box-commonfooter">
                  <span onClick={() => this.closeChangeProduct('changeSameProductStatus')} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                </div> */}
                            </div>
                    }
                </div>
                <SkuMappingsModule
                    showModal={this.state.skuMappingsModuleDailog}
                    shopId={this.state.selectProduct && this.state.selectProduct.ShopId}
                    platformType={this.state.selectProduct && this.state.selectProduct.PlatformType}
                    relationData={this.state.relationApiData}
                    selectProductSkuId={this.state.selectProductSkuId}
                    closeSkuMappingsModule={this.closeSkuMappingsModule}
                    onChangeSupplierProduct={this.onChangeSupplierProduct}
                    saveSure={this.sureSkuMapping}
                    isOrderListOpen={this.state.isChangeSp}
                    isTwoOpen={true}
                ></SkuMappingsModule>
                <ShowModal titleName={"货源不支持铺货代发"} showModal={this.state.showNotFoundSupplierProductError} hideBtn={true} width={'450px'} cancelDailog={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} showLeftTopBtn={true}
                    titleIcon={<span className='iconfont icon-gantan warnColor' style={{ fontSize: '24px', marginRight: '10px' }}></span>} >
                    <div style={{ fontSize: '16px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div>
                            <span>该货源未获得分销授权，无法进行铺货、关联、更换。您可以换个货源或者联系供应商将该商品设置为支持分销</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => window.open('https://www.yuque.com/jessie-bvwmn/qqsqc7/gtpzq3', '_blank')} className="showModalWrap-box-footer-btn">查看教程</span>
                        <span onClick={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>
                <MyLoading isLoading={this.state.isLoading} title={this.state.loadingTitle} isStopOperate={true} fullCenter={true} />
            </ShowModal>
        );
    }



};

export default withRouter(ChangeProductsModuleV2);



// WEBPACK FOOTER //
// ./src/components/changeProductsModuleV2/index.jsx